import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TableSortPill } from '@shared-modules/table-shared/_core';
import { SortOrderEnum } from '@shared/enums';
import { ChipModule } from 'primeng/chip';

@Component({
    selector: 'app-table-sort-pill[id][data]',
    templateUrl: './table-sort-pill.component.html',
    styleUrls: ['./table-sort-pill.component.scss'],
    standalone: true,
    imports: [TranslateModule, ChipModule],
})
export class TableSortPillComponent {
    @Input() id: string = '';
    @Input() data: TableSortPill[] = [];
    @Output() clickPill = new EventEmitter<void>();

    sortOrder = SortOrderEnum;
}
